import { authHeader } from '@/_helpers';
export const workspaceService = {
    getWorkspaceAdmins,
    getWorkspaceDomains,
    getWorkspaceUsers
};

const apiUrl = process.env.VUE_APP_ROOT_API;

 
function getWorkspaceAdmins() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/workspace/get-workspace-admins`, requestOptions).then(handleResponse);
}

function getWorkspaceDomains(workspace_id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/workspace/get-workspace-domains/${workspace_id}`, requestOptions).then(handleResponse);
}

function getWorkspaceUsers(workspace_id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/workspace/get-workspace-users/${workspace_id}`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = data || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
